const TITLE_MAX = 60
const DESCRIPTION_MIN = 110
const DESCRIPTION_MAX = 160
const BRAND_SUFFIX = ' | Recall Monitor'
const DESCRIPTION_CTA = ' Check affected products and what to do.'
const DESCRIPTION_PAD = ' Canadian recall details from official sources.'

const PROTECTED_RECALL_IDS = Object.freeze([
  '2021024',
  '11-21_64278',
  '11-21_64186',
  '11-21_64249',
  '11-21_62508',
  '2021039',
  '2021177',
  '11-21_74063',
  '75021',
  '11-21_63975',
  '2021506',
  '11-21_72963',
  '2022650',
  '2020294',
  '75935',
  '2020494',
  '2021210',
  '2020496',
  '2020516',
])

function clipAtWord(text, maxLen) {
  if (!text) return ''
  if (text.length <= maxLen) return text
  if (maxLen <= 1) return '…'
  const slice = text.slice(0, maxLen - 1)
  const lastSpace = slice.lastIndexOf(' ')
  const minBreak = Math.floor(maxLen * 0.6)
  const clipped = lastSpace >= minBreak ? slice.slice(0, lastSpace) : slice
  return clipped.replace(/[\s,;:.]+$/g, '') + '…'
}

function buildRecallTitle(parsedTitle) {
  const lead = String(parsedTitle || '').trim() || 'Recall'
  const full = `${lead}${BRAND_SUFFIX}`
  if (full.length <= TITLE_MAX) return full
  const budget = TITLE_MAX - BRAND_SUFFIX.length
  return `${clipAtWord(lead, budget)}${BRAND_SUFFIX}`
}

function buildRecallDescription({ title, alertType } = {}) {
  const rawTitle = String(title || '').trim() || 'This recall'
  const type = String(alertType || '').trim()
  const prefix = type ? `${type}: ` : ''
  const suffix = `.${DESCRIPTION_CTA}`
  const full = `${prefix}${rawTitle}${suffix}`

  let description
  if (full.length <= DESCRIPTION_MAX) {
    description = full
  } else {
    const budget = DESCRIPTION_MAX - prefix.length - suffix.length
    description = `${prefix}${clipAtWord(rawTitle, Math.max(budget, 1))}${suffix}`
  }

  if (description.length < DESCRIPTION_MIN) {
    description = `${description}${DESCRIPTION_PAD}`
  }
  if (description.length < DESCRIPTION_MIN) {
    description = `${description} Learn more before you use or keep the product.`
  }
  if (description.length > DESCRIPTION_MAX) {
    description = clipAtWord(description, DESCRIPTION_MAX)
  }

  return description
}

function buildRecallCanonical(apiId) {
  return `https://recallmonitor.ca/recall/${apiId}`
}

module.exports = {
  TITLE_MAX,
  DESCRIPTION_MIN,
  DESCRIPTION_MAX,
  BRAND_SUFFIX,
  PROTECTED_RECALL_IDS,
  clipAtWord,
  buildRecallTitle,
  buildRecallDescription,
  buildRecallCanonical,
}
